"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionCreators = exports.ActionTypes = void 0;
const apikey_1 = require("./apikey");
const bank_1 = require("./bank");
const bankAccount_1 = require("./bankAccount");
const bulkOrders_1 = require("./bulkOrders");
const candlestick_1 = require("./candlestick");
const connection_1 = require("./connection");
const currency_1 = require("./currency");
const deposit_1 = require("./deposit");
const kyc_1 = require("./kyc");
const lastTrades_1 = require("./lastTrades");
const loginHistory_1 = require("./loginHistory");
const market_1 = require("./market");
const message_1 = require("./message");
const openOrders_1 = require("./openOrders");
const order_1 = require("./order");
const orderbook_1 = require("./orderbook");
const ordersHistory_1 = require("./ordersHistory");
const security_1 = require("./security");
const subscribe_1 = require("./subscribe");
const ticker_1 = require("./ticker");
const trades_1 = require("./trades");
const unsubscribe_1 = require("./unsubscribe");
const user_1 = require("./user");
const wallet_1 = require("./wallet");
const withdraw_1 = require("./withdraw");
const ws_1 = require("./ws");
__exportStar(require("./apikey"), exports);
__exportStar(require("./bank"), exports);
__exportStar(require("./bankAccount"), exports);
__exportStar(require("./bulkOrders"), exports);
__exportStar(require("./candlestick"), exports);
__exportStar(require("./connection"), exports);
__exportStar(require("./currency"), exports);
__exportStar(require("./deposit"), exports);
__exportStar(require("./kyc"), exports);
__exportStar(require("./lastTrades"), exports);
__exportStar(require("./loginHistory"), exports);
__exportStar(require("./market"), exports);
__exportStar(require("./message"), exports);
__exportStar(require("./openOrders"), exports);
__exportStar(require("./order"), exports);
__exportStar(require("./orderbook"), exports);
__exportStar(require("./ordersHistory"), exports);
__exportStar(require("./security"), exports);
__exportStar(require("./subscribe"), exports);
__exportStar(require("./ticker"), exports);
__exportStar(require("./trades"), exports);
__exportStar(require("./unsubscribe"), exports);
__exportStar(require("./user"), exports);
__exportStar(require("./wallet"), exports);
__exportStar(require("./withdraw"), exports);
__exportStar(require("./ws"), exports);
class ActionTypes {
}
exports.ActionTypes = ActionTypes;
ActionTypes.ApiKey = apikey_1.ApiKeyActionTypes;
ActionTypes.Bank = bank_1.BankActionTypes;
ActionTypes.BankAccount = bankAccount_1.BankAccountActionTypes;
ActionTypes.BulkOrders = bulkOrders_1.BulkOrdersActionTypes;
ActionTypes.Candlestick = candlestick_1.CandlestickActionTypes;
ActionTypes.Connection = connection_1.ConnectionActionTypes;
ActionTypes.Currency = currency_1.CurrencyActionTypes;
ActionTypes.Deposit = deposit_1.DepositActionTypes;
ActionTypes.Kyc = kyc_1.KycActionTypes;
ActionTypes.LastTrades = lastTrades_1.LastTradesActionTypes;
ActionTypes.LoginHistory = loginHistory_1.LoginHistoryActionTypes;
ActionTypes.Market = market_1.MarketActionTypes;
ActionTypes.Message = message_1.MessageActionTypes;
ActionTypes.OpenOrders = openOrders_1.OpenOrdersActionTypes;
ActionTypes.Order = order_1.OrderActionTypes;
ActionTypes.Orderbook = orderbook_1.OrderbookActionTypes;
ActionTypes.OrdersHistory = ordersHistory_1.OrdersHistoryActionTypes;
ActionTypes.Security = security_1.SecurityActionTypes;
ActionTypes.Subscribe = subscribe_1.SubscribeActionTypes;
ActionTypes.Ticker = ticker_1.TickerActionTypes;
ActionTypes.Trades = trades_1.TradesActionTypes;
ActionTypes.Unsubscribe = unsubscribe_1.UnsubscribeActionTypes;
ActionTypes.User = user_1.UserActionTypes;
ActionTypes.Wallet = wallet_1.WalletActionTypes;
ActionTypes.Withdraw = withdraw_1.WithdrawActionTypes;
ActionTypes.WS = ws_1.WSActionTypes;
class ActionCreators {
}
exports.ActionCreators = ActionCreators;
ActionCreators.ApiKey = apikey_1.ApiKeyActionCreators;
ActionCreators.Bank = bank_1.BankActionCreators;
ActionCreators.BankAccount = bankAccount_1.BankAccountActionCreators;
ActionCreators.BulkOrders = bulkOrders_1.BulkOrdersActionCreators;
ActionCreators.Candlestick = candlestick_1.CandlestickActionCreators;
ActionCreators.Connection = connection_1.ConnectionActionCreators;
ActionCreators.Currency = currency_1.CurrencyActionCreators;
ActionCreators.Deposit = deposit_1.DepositActionCreators;
ActionCreators.Kyc = kyc_1.KycActionCreators;
ActionCreators.LastTrades = lastTrades_1.LastTradesActionCreators;
ActionCreators.LoginHistory = loginHistory_1.LoginHistoryActionCreators;
ActionCreators.Market = market_1.MarketActionCreators;
ActionCreators.Message = message_1.MessageActionCreators;
ActionCreators.OpenOrders = openOrders_1.OpenOrdersActionCreators;
ActionCreators.Order = order_1.OrderActionCreators;
ActionCreators.Orderbook = orderbook_1.OrderbookActionCreators;
ActionCreators.OrdersHistory = ordersHistory_1.OrdersHistoryActionCreators;
ActionCreators.Security = security_1.SecurityActionCreators;
ActionCreators.Subscribe = subscribe_1.SubscribeActionCreators;
ActionCreators.Ticker = ticker_1.TickerActionCreators;
ActionCreators.Trades = trades_1.TradesActionCreators;
ActionCreators.Unsubscribe = unsubscribe_1.UnsubscribeActionCreators;
ActionCreators.User = user_1.UserActionCreators;
ActionCreators.Wallet = wallet_1.WalletActionCreators;
ActionCreators.Withdraw = withdraw_1.WithdrawActionCreators;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/exchange-common/actions/index.js
// module id = 208
// module chunks = 0